import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox } from '@mui/material';

import asyncService from '../../../datahub/asyncService';
import selectUser from '../../store/selectors/appSelector';

import ItemList from './ItemList';

const PositionTemplateEntry = ({ name, description, isChecked, onChange }) => (
  <>
    <Checkbox
      size="small"
      //   disabled={!isAllSelected}
      checked={!!isChecked}
      // onClick={(e) => e.stopPropagation()}
      onChange={onChange}
    />
    {name}, {description}
  </>
);
PositionTemplateEntry.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
};

const PositionTemplateSelectionList = ({
  corpId,
  isReadyToLoad,
  positionTemplateData,
  setPositionTemplateData,
}) => {
  const { token, refreshToken } = useSelector(selectUser);

  const dispatch = useDispatch();

  const buildPositionTemplateItemToDisplay = (pt) => (
    <PositionTemplateEntry
      key={pt?._id}
      name={pt?.name}
      description={pt?.description}
      isChecked={pt?.isSelected}
      onChange={() =>
        setPositionTemplateData(
          positionTemplateData.map(
            (x) => (x?._id === pt?._id && { ...pt, isSelected: !pt?.isSelected }) || x
          )
        )
      }
    />
  );

  const corporationFilter = {
    field: 'corporation._id',
    operation: 'equalsID',
    value: corpId,
  };

  const positionTemplateListSearchData = {
    filters: [corporationFilter], // candidate filter + any custom filters
    limit: 10,
  };

  const positionTemplatesRequest = (
    setNeededDocumentCount,
    setIsLoading,
    page,
    currentPositionTemplateData
  ) =>
    asyncService({
      httpMethod: 'POST',
      route: 'position-templates/read',
      data: { ...positionTemplateListSearchData, page },
      onSuccess: (results) => {
        const positionTemplateDocuments = results?.data?.documents || [];
        const totalDocCount = results?.data?.count || 0;
        setNeededDocumentCount(totalDocCount);
        setPositionTemplateData([...currentPositionTemplateData, ...positionTemplateDocuments]);
        setIsLoading(false);
      },
      onError: () => {
        // handle error
        setIsLoading(false);
      },
      dispatch,
      token,
      refreshToken,
    });

  return (
    <ItemList
      buildItemToDisplay={buildPositionTemplateItemToDisplay}
      isReadyToLoad={isReadyToLoad}
      requestApi={positionTemplatesRequest}
      items={positionTemplateData}
    />
  );
};

PositionTemplateSelectionList.propTypes = {
  corpId: PropTypes.string,
  isReadyToLoad: PropTypes.bool,
  positionTemplateData: PropTypes.arrayOf(PropTypes.shape({})),
  setPositionTemplateData: PropTypes.func,
};

export default PositionTemplateSelectionList;
